import styled, { css } from "styled-components";
import { bettoWalletCssVariables, BTTO_WALLET_GLASS } from "../../shared/bettoWalletTheme";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

const bettoGlassPanel = css`
	background: ${BTTO_WALLET_GLASS.panelBg} !important;
	backdrop-filter: blur(12px) saturate(130%);
	-webkit-backdrop-filter: blur(12px) saturate(130%);
`;

const bettoGlassCard = css`
	background: ${BTTO_WALLET_GLASS.cardBg} !important;
	backdrop-filter: blur(${BTTO_WALLET_GLASS.blur}) saturate(140%);
	-webkit-backdrop-filter: blur(${BTTO_WALLET_GLASS.blur}) saturate(140%);
	border: 1px solid ${BTTO_PROFILE_COLORS.border} !important;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);
`;

export const WalletWrapper = styled.div.attrs({
	className: "bt-betto-wallet",
})`
	display: flex;
	flex-direction: column;
	gap: 0;
	width: 100%;
	min-width: 0;
	${bettoWalletCssVariables}

	&.bt-betto-wallet {
		.profile-page-wrapper,
		.profile-page-wrapper.payment-page {
			background: transparent !important;
			padding: 0 !important;
			border-radius: 0 !important;
		}

		.profile-page-content,
		.sub-page-content {
			padding: 0 !important;
		}

		.cube-form-wrapper {
			width: 100%;
			min-width: 0;
		}

		[data-testid="step-deposit-method-selection"],
		[data-testid="step-withdraw-method-selection"] {
			@media (min-width: 768px) {
				grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
			}

			@media (min-width: 1200px) {
				grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
			}
		}

		[data-testid="step-deposit-method-selection"] > div,
		[data-testid="step-withdraw-method-selection"] > div,
		[class*="DepositItem"],
		[class*="WithdrawItem"] {
			border-radius: 12px !important;
			overflow: hidden;
			transition:
				border-color 0.2s ease,
				box-shadow 0.2s ease;
			${bettoGlassCard}

			[class*="DepositContentWrapper"],
			[class*="WithdrawContentWrapper"],
			[class*="MinMaxWrapper"] {
				transition:
					background 0.2s ease,
					border-color 0.2s ease;
			}

			&:hover {
				border-color: ${BTTO_PROFILE_COLORS.borderActive} !important;
				box-shadow: 0 6px 28px rgba(3, 98, 212, 0.14) !important;

				[class*="DepositContentWrapper"],
				[class*="WithdrawContentWrapper"] {
					background: ${BTTO_WALLET_GLASS.contentHoverBg} !important;
					border-color: rgba(3, 98, 212, 0.22) !important;
				}

				[class*="MinMaxWrapper"] {
					background: ${BTTO_WALLET_GLASS.panelHoverBg} !important;
					border: 1px solid ${BTTO_WALLET_GLASS.panelHoverBorder} !important;
					box-shadow: inset 0 0 20px rgba(3, 98, 212, 0.06);
				}

				[class*="DepositButton"],
				[class*="WithdrawButton"] {
					background: ${BTTO_PROFILE_COLORS.primaryDark} !important;
				}

				[class*="Value"],
				[class*="MinOrMax"],
				[class*="NameDesktop"],
				[class*="NameFeaturesWrapper"],
				[class*="DepositNameMobile"],
				[class*="WithdrawNameMobile"] {
					color: ${BTTO_PROFILE_COLORS.text} !important;
				}
			}
		}

		@media (max-width: 1023px) {
			[class*="MinMaxWrapper"] {
				background: ${BTTO_WALLET_GLASS.panelBg} !important;
				border-radius: 6px;
				padding: 6px 8px !important;
				margin: 2px 0;
				border: 1px solid ${BTTO_WALLET_GLASS.border};
			}

			[class*="DepositContentWrapper"],
			[class*="WithdrawContentWrapper"] {
				background: ${BTTO_WALLET_GLASS.contentBg} !important;
				gap: 4px !important;
			}
		}

		[class*="DepositButton"],
		[class*="WithdrawButton"] {
			background: ${BTTO_PROFILE_COLORS.primary} !important;
			border-radius: 0 12px 12px 0 !important;

			@media (min-width: 1024px) {
				border-radius: 8px !important;
			}
		}

		[class*="MinMaxWrapper"] {
			${bettoGlassPanel}
			border: 1px solid ${BTTO_WALLET_GLASS.border};

			@media (min-width: 1024px) {
				border-top: 1px solid ${BTTO_WALLET_GLASS.border};
				border-bottom: 1px solid ${BTTO_WALLET_GLASS.border};
				border-left: none;
				border-right: none;
			}
		}

		[class*="DepositContentWrapper"],
		[class*="WithdrawContentWrapper"] {
			background: ${BTTO_WALLET_GLASS.contentBg} !important;
			backdrop-filter: blur(12px) saturate(130%);
			-webkit-backdrop-filter: blur(12px) saturate(130%);
			border-radius: 0 !important;
			border-left: 1px solid ${BTTO_WALLET_GLASS.border};
			border-right: 1px solid ${BTTO_WALLET_GLASS.border};

			@media (min-width: 1024px) {
				background: transparent !important;
				backdrop-filter: none;
				-webkit-backdrop-filter: none;
				border: none !important;
			}
		}

		[class*="DepositLogoWrapper"],
		[class*="WithdrawLogoWrapper"] {
			background: transparent !important;
		}

		.bank-img:not(.no-filter) {
			filter: brightness(0) invert(1);
		}

		[data-testid^="step-deposit-"][data-testid$="-header"],
		[data-testid^="step-withdraw-"][data-testid$="-header"] {
			padding: 16px;
			border-radius: 12px;
			background: ${BTTO_PROFILE_COLORS.surface};
			border: 1px solid ${BTTO_PROFILE_COLORS.border};
			margin-bottom: 16px;
			margin-top: 16px;
		}

		[data-testid="step-deposit-amount-title"],
		[data-testid^="step-deposit-"][data-testid$="-title"],
		[data-testid^="step-withdraw-"][data-testid$="-title"],
		.cube-form-wrapper [class*="ContentTitle"] {
			border: 1px solid ${BTTO_PROFILE_COLORS.border} !important;
			border-top: 1px solid ${BTTO_PROFILE_COLORS.border} !important;
			border-radius: 10px !important;
			background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
			color: ${BTTO_PROFILE_COLORS.text} !important;
			font-size: 13px !important;
			font-weight: 600 !important;
			margin-bottom: 16px;
		}

		[data-testid="step-deposit-amount-currency-picker-label"],
		[class*="BoxTitle"] {
			color: ${BTTO_PROFILE_COLORS.textMuted} !important;
		}

		[class*="AmountFieldsGrid"] {
			width: 100%;
		}

		.cube-form-wrapper [class*="MaskedInput"] {
			width: 100%;
			margin-top: 16px;
		}

		.cube-form-wrapper [class*="MaskedInput"] input {
			border-radius: 8px !important;
			border: 1px solid ${BTTO_PROFILE_COLORS.border} !important;
			background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
			color: ${BTTO_PROFILE_COLORS.text} !important;
			height: 44px !important;
			font-size: 14px !important;

			&:focus {
				border-color: ${BTTO_PROFILE_COLORS.borderActive} !important;
				background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
				outline: none !important;
			}
		}

		.cube-form-wrapper [class*="MaskedInputLabel"] {
			color: ${BTTO_PROFILE_COLORS.textMuted} !important;
		}

		[data-testid="step-deposit-amount-limits"],
		[data-testid="step-withdraw-amount-limits"] {
			display: block;
			width: 100%;
			color: ${BTTO_PROFILE_COLORS.textDim};
			font-size: 11px;
			line-height: 1.4;
			text-align: left;
		}

		[data-testid="step-deposit-amount-amount-input"],
		.cube-form-wrapper input,
		.cube-form-wrapper textarea {
			border-radius: 8px !important;
			border: 1px solid ${BTTO_PROFILE_COLORS.border} !important;
			background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
			color: ${BTTO_PROFILE_COLORS.text} !important;
			height: 44px !important;
			font-size: 14px !important;

			&:focus {
				border-color: ${BTTO_PROFILE_COLORS.borderActive} !important;
				outline: none !important;
			}
		}

		.select-wrapper,
		.selector-wrapper {
			width: 100% !important;
			max-width: 100% !important;
			min-width: 0 !important;
			height: 44px !important;
		}

		.selector-wrapper .selector-control {
			height: 44px !important;
			min-height: 44px !important;
			padding: 0 14px !important;
			border-radius: 8px !important;
			border: 1px solid ${BTTO_PROFILE_COLORS.border} !important;
			background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
			color: ${BTTO_PROFILE_COLORS.text} !important;
			text-align: left !important;
			font-size: 14px !important;
			font-weight: 400 !important;
			line-height: 44px !important;
		}

		.selector-wrapper .selector-selected,
		.selector-wrapper .selector-selected .selector-selected-item,
		.selector-wrapper .selector-placeholder {
			text-align: left !important;
			font-size: 14px !important;
			font-weight: 400 !important;
			line-height: 44px !important;
		}

		.selector-wrapper .selector-list {
			background: ${BTTO_PROFILE_COLORS.surface} !important;
			border: 1px solid ${BTTO_PROFILE_COLORS.border} !important;
			border-radius: 0 0 8px 8px !important;
		}

		.selector-option {
			color: ${BTTO_PROFILE_COLORS.text} !important;

			&:hover {
				background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
			}
		}

		[class*="StakeFieldWrapper"] {
			gap: 6px;

			.stake-field > div {
				align-items: stretch !important;
				margin-bottom: 0 !important;
			}

			.stake-field,
			.min-max-field {
				position: static !important;
				width: 100% !important;
				right: auto !important;
				text-align: left !important;
			}
		}

		[data-testid="step-deposit-amount-limits"],
		[class*="MinMaxInfo"] {
			color: ${BTTO_PROFILE_COLORS.textDim} !important;
			font-size: 11px !important;
			line-height: 1.4 !important;
		}

		[class*="Feature"],
		[class*="FeatureBankName"] {
			color: ${BTTO_PROFILE_COLORS.textMuted} !important;
		}

		[class*="FeatureBankName"] {
			color: ${BTTO_PROFILE_COLORS.text} !important;
		}

		[class*="ExternalButton"] {
			border-radius: 8px !important;
			background: ${BTTO_PROFILE_COLORS.primary} !important;
			color: ${BTTO_PROFILE_COLORS.primaryText} !important;
		}

		[class*="Value"],
		[class*="MinOrMax"],
		[class*="DepositNameDesktop"],
		[class*="DepositNameMobile"],
		[class*="WithdrawNameDesktop"],
		[class*="WithdrawNameMobile"],
		[class*="DepositNameFeaturesWrapper"],
		[class*="WithdrawNameFeaturesWrapper"] {
			color: ${BTTO_PROFILE_COLORS.textMuted};
		}

		[class*="Value"] {
			color: ${BTTO_PROFILE_COLORS.text} !important;
		}

		[class*="Text"] {
			color: ${BTTO_PROFILE_COLORS.primaryText} !important;
		}

		[class*="BonusDescription"] {
			background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
			border: 1px solid ${BTTO_PROFILE_COLORS.border};
			border-radius: 12px;
		}
	}
`;

export const WalletMain = styled.div`
	flex: 1;
	min-width: 0;
	width: 100%;
`;

export const WalletNavSlot = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: 20px 16px 12px;
	background: transparent;
	border: none;
	border-top: 1px solid ${BTTO_PROFILE_COLORS.border};
	margin-top: 8px;

	&:empty {
		display: none;
		padding: 0;
		border: none;
		margin: 0;
	}
`;
